var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql } from '@apollo/client/core';
import * as Event from './Event';
import * as AggregatedEventSales from './AggregatedEventSales';
export const EVENT_DETAILS_FRAGMENT = gql `
  fragment EventDetails on Event {
    id
    name
    date
    doorTime
    startTime
    state
    ticketSales {
      totalTicketsSoldToday
      totalTicketsSalesToday
      totalTicketsSold
      totalTicketsSales
      totalTicketsOnHold
      totalSalesLimit
      totalTicketsAvailable
      totalTickets
    }
  }
`;
export const ALL_EVENTS_QUERY = gql `
  query allEvents($page: Int!, $pageSize: Int!) {
    app {
      events(arguments: { pageSize: $pageSize, page: $page }) {
        collection {
          ...EventDetails
        }
        metadata {
          totalCount
          totalPages
          currentPage
          limitValue
        }
      }
    }
  }
  ${EVENT_DETAILS_FRAGMENT}
`;
export const AGGREGATED_EVENT_SALES_QUERY = gql `
  query AggregatedEventSales {
    app {
      aggregatedEventSales {
        salesData {
          totalSales
          totalSalesLimit
          ticketsSold
          totalTickets
          totalTicketsSalesToday
          totalTicketsSoldToday
          totalSalesLimit
        }
      }
    }
  }
`;
export const getEvents = (client, page, pageSize) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const { data } = yield client.query({
        query: ALL_EVENTS_QUERY,
        variables: { page, pageSize },
        fetchPolicy: 'network-only',
    });
    if (!((_b = (_a = data.app) === null || _a === void 0 ? void 0 : _a.events) === null || _b === void 0 ? void 0 : _b.collection)) {
        throw new Error('Failed to fetch events.');
    }
    return Event.fromGqlCollection(data.app.events.collection);
});
export const getAggregatedEventSales = (client) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const { data } = yield client.query({
        query: AGGREGATED_EVENT_SALES_QUERY,
        fetchPolicy: 'network-only',
    });
    if (!((_a = data.app) === null || _a === void 0 ? void 0 : _a.aggregatedEventSales)) {
        throw new Error('Failed to fetch aggregated event sales.');
    }
    return AggregatedEventSales.fromGql(data.app.aggregatedEventSales);
});
//# sourceMappingURL=Api.js.map